import { formatInTimeZone } from 'date-fns-tz';
import {
  formatAcademyDate,
  formatAcademyDateTime,
  getDisplayTime as getSharedDisplayTime
} from 'utils/format';
import { academyLogger } from "utils/logger";

const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date);
};

export const FormatDateTime = (date) => {
  const dateObj = new Date(date);
  if (!isValidDate(dateObj)) {
    academyLogger.error('Invalid date:', date);
    return 'Invalid Date';
  }
  return formatInTimeZone(dateObj, 'UTC', 'yyyy-MM-dd HH:mm:ss');
};

export const FormatDate = (date, formatString = 'MMM dd, yyyy') => {
  const dateObj = new Date(date);
  if (!isValidDate(dateObj)) {
    return '-';
  }

  if (formatString === 'MMM dd, yyyy') {
    return formatAcademyDate(dateObj);
  }

  return formatInTimeZone(dateObj, 'UTC', formatString);
};

export const getDisplayTime = (time) => {
  return getSharedDisplayTime(time);
};

export { formatAcademyDate, formatAcademyDateTime };
